import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileFormComponent } from './profile-form/profile-form.component';
import { MaterialModule } from '../material/material.module';
import { SharedModule } from '../shared/shared.module';
import { RegisterComponent } from './register/register.component';
import { NovoConvertidoComponent } from './novo-convertido/novo-convertido.component';
import { ComponentsModule } from '../components/components.module';
import { ImageCropperModule } from 'ngx-image-cropper';

@NgModule({
  declarations: [ProfileFormComponent, RegisterComponent, NovoConvertidoComponent],
  imports: [CommonModule, MaterialModule, SharedModule, ComponentsModule, ImageCropperModule],
})
export class AccountModule {}
